import { render } from "./FooterMenu.vue?vue&type=template&id=6539dc76"
import script from "./FooterMenu.vue?vue&type=script&lang=js"
export * from "./FooterMenu.vue?vue&type=script&lang=js"
script.render = render

export default script